import React from "react";
import { Link } from "react-router-dom";
import { config } from "../../pages/config";

const Cta = () => {
    return (

        <section class="ready-to-talk inner-header">
            <div className="bg-overlay"></div>
            <div class="container">
                <h2 style={{color: "#fff"}}>Looking to Buy or Sell Aluminum?</h2>
                <p>Contact Roliox Alloys for reliable supply or scrap purchase inquiries.</p>
                <Link to={`${config.appUrl}contact-us`} className="btn btn-primary">Contact Us</Link>
            </div>
        </section>
    );
};

export default Cta;
